import { yup } from '@guiker/yup-util'

export const generatePDFPayloadSchema = yup.object({
  template: yup.string().required(),
  data: yup.mixed().required(),
})
